import React from 'react';
import './AuroraBackground.css';

// Reusable warm pastel aurora field (CSS-keyframe drift). Drop it as the first
// child of a `relative` page wrapper; keep page content at a higher z-index.
const AuroraBackground = () => (
  <div aria-hidden="true" className="aurora-field">
    <span className="aurora-blob b1" />
    <span className="aurora-blob b2" />
    <span className="aurora-blob b3" />
    <span className="aurora-blob b4" />
  </div>
);

export default AuroraBackground;
